import { getEmirExport } from '../emir.routes';

export const EMIR_EXPORT_ID = 'emir-export';

export const downloadEmirExport = ({
  positionDate,
  raptorPlatformId,
}: {
  positionDate: string;
  raptorPlatformId?: string;
}) => getEmirExport(positionDate, raptorPlatformId);
